// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2c4e58ac","8":"0715b470","31":"f90669a9","144":"0cd55c20"}[chunkId] + ".chunk.js";
};